<template>
  <div>
    <el-input :size="size" placeholder="请直接输入或绑定数据源" :value="text" readonly>
      <table class="property-field-table" cellspacing="0" cellpadding="0" slot="append">
        <tr>
          <td @click="clear">&times;</td>
          <td @click="toInputText">直接输入</td>
          <td @click="toSelectDataSource">绑定数据源</td>
        </tr>
      </table>
    </el-input>
    <text-input-dialog ref="textInputDialog" @save="onSave1"></text-input-dialog>
    <data-source-select-dialog ref="dataSourceSelectDialog" dataType="FIELD" :configColumn="true" :configCondition="true" :configOperation="false" :endpoint="endpoint" :uiId="uiId" @save="onSave2"></data-source-select-dialog>
  </div>
</template>

<script>
import TextInputDialog from '../model/TextInputDialog'
import DataSourceSelectDialog from '../model/DataSourceSelectDialog'

export default {
  name: 'text-input-button',
  components: {
    TextInputDialog,
    DataSourceSelectDialog
  },
  props: {
    endpoint: { type: String, required: true },
    property: { type: Object, required: true },
    size: { type: String, required: false, default: 'mini' },
    uiId: { type: Number, required: true }
  },
  data () {
    return {
      text: null,
      words: null,
      dataSource: null
    }
  },
  watch: {
    'property.value': {
      handler: function (val) {
        if (!val) {
          this.text = null
          this.words = null
          this.dataSource = null
          return
        }

        try {
          val = JSON.parse(val)
        } catch (e) {
          // do nothing
        }
        if (val && val.id) {
          this.text = this.getText(val)
          this.words = null
          this.dataSource = val
        } else {
          this.text = val ? ('直接输入: ' + val) : null
          this.words = val
          this.dataSource = null
        }
      },
      immediate: true
    }
  },
  methods: {
    clear () {
      this.text = null
      this.words = null
      this.dataSource = null
      this.property.value = undefined
      this.$emit('change')
    },
    toInputText () {
      this.$refs.textInputDialog.open()
    },
    toSelectDataSource () {
      if (this.dataSource) {
        this.$refs.dataSourceSelectDialog.open(this.property.value)
      } else {
        this.$refs.dataSourceSelectDialog.open()
      }
    },
    onSave1 (words) {
      this.text = words ? ('直接输入: ' + words) : null
      this.words = words
      this.dataSource = null
      this.property.value = words
      this.$emit('change')
    },
    onSave2 (dataSource) {
      this.text = (dataSource && dataSource.id) ? this.getText(dataSource) : null
      this.words = null
      this.dataSource = dataSource
      this.property.value = JSON.stringify(dataSource)
      this.$emit('change')
    },
    getText (dataSource) {
      let type = dataSource.type
      if (type === 'model') {
        return `数据源 - 模型: ${dataSource.name}`
      }
      if (type === 'dynamicForm') {
        return `数据源 - 动态表单: ${dataSource.name}`
      }
      if (type === 'apiDataSource') {
        return `数据源 - API数据源: ${dataSource.name}`
      }
      return dataSource.name
    }
  }
}
</script>
